export default {
    getUserId(state) {
        return state.id
    }
}
